import { Chart } from 'chart.js'

// A stacked chart with many sparse series (tests per account per day) puts a row
// per series into the tooltip, almost all of them zero. Opt out of those rows with
// `library: { hideZeroSeries: true }` and show the ones with data, largest first.
Chart.register({
  id: 'hideZeroSeries',
  beforeInit(chart) {
    if (!chart.options.hideZeroSeries) return

    const tooltip = chart.options.plugins.tooltip
    tooltip.displayColors = true
    tooltip.filter = (item) => Boolean(item.parsed.y)
    tooltip.itemSort = (a, b) => b.parsed.y - a.parsed.y
  }
})
